<template>
  <div class="designer-subsection">
    <header>
      <div class="wrapper">
        <span class="index">
          {{ getIndex }}
        </span>
        <span class="label">
          {{ label }}
        </span>
      </div>
    </header>
    <main>
      <slot/>
    </main>
  </div>
</template>

<script>
export default {
  name: 'DesignerSubsection',
  props: {
    parentIndex: {
      type: Number,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    subsection: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    }
  },
  computed: {
    getIndex () {
      return (this.parentIndex + 1) + '.' + (this.index + 1)
    }
  }
}
</script>

<style
  lang="scss"
  scoped
>
  .designer-subsection {
    padding: 10px 0;
    hr {
      content: '';
      border-top: 1px solid #dddddd;
      display: block;
      width: 100%;
      margin-top: 10px;
    }
    .wrapper {
      margin-top: -25px;
      text-align: center;
      .label {
        @include font-primary(13px, regular);
        color: #666666;
        background-color: #f0f0f0;
        padding: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/designer/_shared/designer-subsection.vue